(function () {
  if (window.FJBCCampaignSource) return;
  window.FJBCCampaignSource = true;

  var STORAGE_KEY = 'fjbc:campaign-source:v1';
  var KEYS = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content'];
  var FIELD_SELECTOR = 'input[type="hidden"][data-campaign-field]';
  var consentReady = false;
  var consentResolved = false;
  var firstTouch = null;
  function allowed() {
    try {
      var privacy = window.Shopify.customerPrivacy;
      return consentReady && privacy.analyticsProcessingAllowed() === true && privacy.marketingAllowed() === true;
    } catch (error) { return false; }
  }

  // Keep campaign labels only, never full URLs, email addresses or other query fields.
  function label(value) {
    return typeof value === 'string' && /^[a-zA-Z0-9][a-zA-Z0-9_.-]{0,99}$/.test(value) ? value : '';
  }

  function campaign(values) {
    if (!values || typeof values !== 'object' || Array.isArray(values)) return null;
    var clean = {};
    var present = false;
    KEYS.forEach(function (key) {
      clean[key] = label(values[key]);
      if (clean[key]) present = true;
    });
    return present ? clean : null;
  }

  function storedCampaign() {
    if (!allowed()) return null;
    try {
      return campaign(JSON.parse(window.sessionStorage.getItem(STORAGE_KEY)));
    } catch (error) {
      return null;
    }
  }

  var params = new URLSearchParams(window.location.search);
  var landing = {};
  KEYS.forEach(function (key) { landing[key] = params.get(key); });
  function syncCampaign() {
    // A saved first touch stays unread while Shopify loads the consent API.
    if (!consentResolved) return;
    if (allowed()) {
      firstTouch = storedCampaign() || firstTouch || campaign(landing);
      if (firstTouch) {
        try { window.sessionStorage.setItem(STORAGE_KEY, JSON.stringify(firstTouch)); }
        catch (error) { /* This page can still carry its labels without storage. */ }
      }
    } else {
      firstTouch = null;
      try { window.sessionStorage.removeItem(STORAGE_KEY); } catch (error) {}
    }
  }

  function populate(root, formData) {
    // Read again on return from the back/forward cache or a later form section load.
    var source = allowed() ? (storedCampaign() || firstTouch) : null;
    root.querySelectorAll(FIELD_SELECTOR).forEach(function (field) {
      var key = field.getAttribute('data-campaign-field');
      if (KEYS.indexOf(key) === -1 || field.name !== 'contact[' + key + ']') return;
      field.value = source ? source[key] : '';
      if (formData) formData.set(field.name, field.value);
    });
  }

  function init(root, formData) {
    syncCampaign();
    populate(document);
    if (formData) populate(root, formData);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); });
  else init();
  window.addEventListener('pageshow', function () { init(); });
  document.addEventListener('shopify:section:load', function () { init(); });
  document.addEventListener('visitorConsentCollected', function () { init(); });
  document.addEventListener('submit', function () { init(); }, true);
  document.addEventListener('formdata', function (event) { init(event.target, event.formData); }, true);
  if (window.Shopify && typeof window.Shopify.loadFeatures === 'function') {
    try {
      window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], function (error) {
        consentReady = !error; consentResolved = true; init();
      });
    } catch (error) { consentReady = false; consentResolved = true; init(); }
  } else { consentResolved = true; init(); }
})();
